import React, { useState } from "react";
import { Wallet, ArrowLeft } from "lucide-react";

const LegalPage = ({ onBack }) => {
  const [tab, setTab] = useState("terms");

  return (
    <div className="min-h-screen bg-page text-color font-sans">
      <header className="sticky top-0 z-50 backdrop-blur-xl border-b border-theme"
        style={{ backgroundColor: "var(--color-bg)", opacity: 0.97 }}>
        <div className="max-w-[800px] mx-auto px-5 py-3.5 flex justify-between items-center">
          <div className="flex items-center gap-2.5">
            <div className="p-2 rounded-xl flex items-center justify-center"
              style={{ background: "linear-gradient(135deg, var(--color-accent), var(--color-accent-soft))" }}>
              <Wallet size={22} color="#fff" />
            </div>
            <span className="text-xl font-bold tracking-tight text-color">ポケ帳</span>
          </div>
          <button onClick={onBack}
            className="flex items-center gap-1.5 text-sm text-accent hover:opacity-80 bg-transparent border-none cursor-pointer">
            <ArrowLeft size={16} /> 戻る
          </button>
        </div>
      </header>

      <main className="max-w-[800px] mx-auto px-5 py-7">
        <div className="flex gap-2 mb-6">
          <button onClick={() => setTab("terms")}
            className={`px-4 py-2 rounded-lg text-sm font-semibold border-none cursor-pointer transition-colors ${
              tab === "terms" ? "text-white" : "text-soft bg-soft"
            }`}
            style={tab === "terms" ? { background: "var(--color-accent)" } : {}}>
            利用規約
          </button>
          <button onClick={() => setTab("privacy")}
            className={`px-4 py-2 rounded-lg text-sm font-semibold border-none cursor-pointer transition-colors ${
              tab === "privacy" ? "text-white" : "text-soft bg-soft"
            }`}
            style={tab === "privacy" ? { background: "var(--color-accent)" } : {}}>
            プライバシーポリシー
          </button>
        </div>

        <div className="card">
          {tab === "terms" ? (
            <div>
              <h2 className="text-lg font-bold mb-4">利用規約</h2>
              <p className="text-sm text-soft mb-2">最終更新日: 2026年3月25日</p>

              <div className="text-sm text-color leading-relaxed">
                <h3 className="font-bold mt-6 mb-2">第1条（適用）</h3>
                <p className="mb-3">本規約は、ポケ帳（以下「本サービス」）の利用に関する条件を定めるものです。ユーザーは本規約に同意の上、本サービスを利用するものとします。</p>

                <h3 className="font-bold mt-6 mb-2">第2条（アカウント）</h3>
                <p className="mb-3">ユーザーはGoogleアカウントまたはメールアドレスにより本サービスに登録できます。アカウント情報の管理はユーザーの責任とします。</p>

                <h3 className="font-bold mt-6 mb-2">第3条（サービス内容）</h3>
                <p className="mb-3">本サービスは、個人事業主および小規模事業者向けの会計管理ツールです。取引の記録、集計、確定申告の準備に関する機能を提供します。本サービスは税務申告そのものを代行するものではありません。</p>

                <h3 className="font-bold mt-6 mb-2">第4条（免責事項）</h3>
                <p className="mb-3">本サービスにより生成されるPDFやデータは参考情報であり、税務申告の正確性を保証するものではありません。確定申告に関する最終判断はユーザー自身の責任で行い、必要に応じて税理士等の専門家にご相談ください。</p>

                <h3 className="font-bold mt-6 mb-2">第5条（禁止事項）</h3>
                <p className="mb-3">ユーザーは以下の行為を行ってはなりません。</p>
                <p className="mb-1 ml-4">・法令に違反する行為</p>
                <p className="mb-1 ml-4">・本サービスの運営を妨げる行為</p>
                <p className="mb-1 ml-4">・他のユーザーの情報を不正に取得する行為</p>
                <p className="mb-3 ml-4">・本サービスを商用目的で無断利用する行為</p>

                <h3 className="font-bold mt-6 mb-2">第6条（サービスの変更・停止）</h3>
                <p className="mb-3">運営者は、事前の通知なくサービスの内容を変更、または一時的もしくは永久に停止できるものとします。</p>

                <h3 className="font-bold mt-6 mb-2">第7条（データの取り扱い）</h3>
                <p className="mb-3">ユーザーが登録したデータの保全には最善を尽くしますが、データの消失や破損に対して運営者は一切の責任を負いません。重要なデータはCSVエクスポート機能等を利用してバックアップをお取りください。</p>

                <h3 className="font-bold mt-6 mb-2">第8条（規約の変更）</h3>
                <p className="mb-3">運営者は本規約を変更できるものとします。変更後の利用規約は、本サービス上に表示した時点で効力を生じます。</p>
              </div>
            </div>
          ) : (
            <div>
              <h2 className="text-lg font-bold mb-4">プライバシーポリシー</h2>
              <p className="text-sm text-soft mb-2">最終更新日: 2026年3月25日</p>

              <div className="text-sm text-color leading-relaxed">
                <h3 className="font-bold mt-6 mb-2">1. 収集する情報</h3>
                <p className="mb-3">本サービスでは以下の情報を収集します。</p>
                <p className="mb-1 ml-4">・メールアドレス（アカウント作成時）</p>
                <p className="mb-1 ml-4">・氏名、住所、電話番号等（基本情報として任意入力）</p>
                <p className="mb-1 ml-4">・取引データ（日付、カテゴリ、金額、備考）</p>
                <p className="mb-3 ml-4">・アップロードされた画像（OCR処理のため一時的に利用）</p>

                <h3 className="font-bold mt-6 mb-2">2. 情報の利用目的</h3>
                <p className="mb-3">収集した情報は以下の目的で利用します。</p>
                <p className="mb-1 ml-4">・本サービスの提供および運営</p>
                <p className="mb-1 ml-4">・ユーザーの会計データの保存・集計・出力</p>
                <p className="mb-1 ml-4">・サービスの改善および新機能の開発</p>
                <p className="mb-3 ml-4">・お問い合わせへの対応</p>

                <h3 className="font-bold mt-6 mb-2">3. 情報の第三者提供</h3>
                <p className="mb-3">ユーザーの同意なく個人情報を第三者に提供することはありません。ただし、法令に基づく場合はこの限りではありません。</p>

                <h3 className="font-bold mt-6 mb-2">4. 外部サービスの利用</h3>
                <p className="mb-3">本サービスでは以下の外部サービスを利用しています。</p>
                <p className="mb-1 ml-4">・Firebase Authentication（ユーザー認証）</p>
                <p className="mb-1 ml-4">・Google Cloud Vision API（OCR処理）</p>
                <p className="mb-3 ml-4">・Heroku（サーバーホスティング）</p>
                <p className="mb-3">各サービスのプライバシーポリシーについては、各提供元のサイトをご確認ください。</p>

                <h3 className="font-bold mt-6 mb-2">5. データの保管</h3>
                <p className="mb-3">ユーザーのデータはセキュアなデータベース（PostgreSQL）に保存されます。通信はSSL/TLSにより暗号化されています。</p>

                <h3 className="font-bold mt-6 mb-2">6. データの削除</h3>
                <p className="mb-3">ユーザーはいつでも自身の取引データを削除できます。アカウントの削除を希望する場合は、運営者にご連絡ください。</p>

                <h3 className="font-bold mt-6 mb-2">7. Cookieの使用</h3>
                <p className="mb-3">本サービスではFirebase Authenticationによるセッション管理のためにCookieまたはローカルストレージを使用しています。</p>

                <h3 className="font-bold mt-6 mb-2">8. ポリシーの変更</h3>
                <p className="mb-3">本ポリシーは必要に応じて変更されることがあります。重要な変更がある場合は、本サービス上でお知らせします。</p>

                <h3 className="font-bold mt-6 mb-2">9. お問い合わせ</h3>
                <p className="mb-3">個人情報の取り扱いに関するお問い合わせは、ログイン後ヘッダーの紙飛行機アイコンからお問い合わせフォームよりご連絡ください。</p>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default LegalPage;